


















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SelectAllMessage',
  props: {
    itemType: {
      type: String,
      required: true,
    },
    serverCount: {
      type: Number,
      required: true,
    },
    rows: {
      type: String,
      required: true,
    },
  },
  setup(_props, { emit }) {
    const emitSelectAll = () => emit('select-full-list');

    return {
      emitSelectAll,
    };
  },
});
